const dashboardEnglish = {
    title: {
        label: "project distribution  based on",
        projects: "number of projects",
        budget: "contract budget",
    },
    barChartLabel: "Wards",
    barChartLabelY: "Number of projects",
    lineChartTitle: "Trend of projects based on agreement date",
    dotChartTitle: "CONTRACTORS VS. USER COMMITTE PROJECTS",
    contractor: "CONTRACTOR PROJECTS",
    user_community: "USER COMMITTEE PROJECTS",
    infrastructure: "INFRASTRUCTURE",
    social: "SOCIAL",
}

const dashboardNepali = {
    title: {
        label: "का आधारमा परियाेजनाकाे वितरण",
        projects: "परियाेजनाहरुकाे संख्या",
        budget: "करार बजेट",
    },
    barChartLabel: "वडाहरू",
    barChartLabelY: "परियाेजनाहरुकाे संख्या",
    lineChartTitle: "सम्झौता मितिका आधारमा परियाेजनाकाे प्रवृत्ति",
    dotChartTitle:
        "निर्माण व्यवसायी एवं उपभाेक्ता समितिबाट सञ्चालित परियाेजनाहरु",
    contractor: "निर्माण व्यवसायीबाट सञ्चालित परियाेजनाहरु",
    user_community: "उपभाेक्ता समितिबाट सञ्चालित परियाेजनाहरु",
    infrastructure: "पूर्वाधार",
    social: "सामाजिक",
}

export {
    dashboardEnglish,
    dashboardNepali,
}



// WEBPACK FOOTER //
// ./src/localization/dashboard.js